module.exports = __webpack_public_path__ + "static/media/IMG-2.fbf8ab9e.jpg";